import { IonChip, IonLabel } from "@ionic/react";
import { Colors, Icon, IconName } from "swing-components";

import { ValuesOf } from "~utils";

// NOTE: This component is fine-tuned for the timesheet page.
//       It is eventually expected to be a re-usable molecule similar to Chip

/***** Types *****/
export type ChipColor =
  | "PURPLE"
  | "RED"
  | "TEAL"
  | "SLATE"
  | "GREEN"
  | "YELLOW"
  | "WHITE"
  | "WHITE200";

export type InteractiveChipProps = {
  color: ChipColor;
  label: string;
  icon?: IconName;
  onClickHandler: () => void;
};

/***** Constants *****/
const CHIP_COLOR: Record<ChipColor, ValuesOf<typeof Colors>> = {
  PURPLE: Colors.purple200,
  SLATE: Colors.slate200,
  TEAL: Colors.teal200,
  RED: Colors.red200,
  GREEN: Colors.green200,
  YELLOW: Colors.yellow200,
  WHITE: Colors.white300,
  WHITE200: Colors.white200,
};

const ICON_COLOR: Record<ChipColor, ValuesOf<typeof Colors>> = {
  PURPLE: Colors.purple500,
  SLATE: Colors.slate600,
  TEAL: Colors.teal500,
  RED: Colors.red500,
  GREEN: Colors.green500,
  YELLOW: Colors.yellow600,
  WHITE: Colors.white300,
  WHITE200: Colors.white200,
};

export function InteractiveChip(props: InteractiveChipProps) {
  const { color, label, icon, onClickHandler } = props;

  return (
    <IonChip
      css={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        whiteSpace: "nowrap",
        minWidth: "80px",
        maxWidth: "360px",
        height: "30px",
        margin: 0,
        padding: "0 8px",
        borderRadius: 16,
        cursor: "pointer",
        pointerEvents: "auto",
        backgroundColor: CHIP_COLOR[color],
        color: Colors.black,
        border: `2px solid #8A95A4`,
      }}
      onClick={onClickHandler}
    >
      {icon ? <Icon name={icon} color={ICON_COLOR[color]} /> : null}
      <IonLabel
        css={{
          fontSize: "14px",
          fontWeight: "var(--swing-font-normal)",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          flex: 1,
          "@media (max-width: 400px)": {
            fontSize: "12px",
          },
        }}
      >
        {label}
      </IonLabel>
      <Icon name="Chevron Down" color={Colors.slate600} />
    </IonChip>
  );
}
